import {
  Box,
  Button,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { DropDownList } from "../Components/DropDownList";
import { useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers";
import { useState } from "react";
import { useAuth } from "../Components/AuthContext";
import { instance } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { LoaderBox } from "../Components/LoaderBox";

function RptDepartamentalMenu() {
  const [departamento, setDepartamento] = useState({ Id: "", Nombre: "" });
  const [area, setArea] = useState({ Id: "", Nombre: "" });
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const { user } = useAuth();
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
    redirect: false,
    page: "/Actividad",
    pageState: {},
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    let form = {
      id: user.id,
      departamento: departamento.Id,
      area: area.Id,
      anio: info.anio.value,
      cooperacion: info.cooperacion.value,
    };
    instance
      .post("reporte/departamento", form)
      .then((res) => {
        navigate("/RptDepartamento", {
          state: {
            data: res.data,
            header: `${departamento.Nombre} ${
              area.Id === "" ? "" : ", Área: " + area.Nombre
            }${info.anio.value === "" ? "" : ", Año: " + info.anio.value}${
              info.cooperacion.value === ""
                ? ""
                : ", Cooperación: " +
                  (info.cooperacion.value === "true" ? "Sí" : "No")
            }`,
          },
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };

  return (
    <LoaderBox>
      <Container
        maxWidth="sm"
        sx={{
          border: { xs: "0", sm: "1px solid #000" },
          mt: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 2,
        }}
        component="form"
        onSubmit={handleSubmit}
      >
        <Typography variant="h5" sx={{ textDecoration: "underline" }}>
          Reporte Departamental
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <DropDownList
              required
              title="Departamento"
              endpoint={"/localidad/listActiveDepartamento"}
              selectedItem={departamento}
              setSelectedItem={setDepartamento}
            />
          </Grid>
          <Grid item xs={12}>
            <DropDownList
              title="Área de trabajo del responsable del UPSE"
              endpoint={"/area"}
              selectedItem={area}
              setSelectedItem={setArea}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              views={["year"]}
              margin="standard"
              fullWidth
              id="anio"
              label="Año que planifica"
              name="anio"
              format="YYYY"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <FormControl>
                <FormLabel>Cooperación Externa</FormLabel>
                <RadioGroup row name="cooperacion">
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Sí"
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                type="submit"
                size="large"
                variant="contained"
                color="success"
                padding={1}
              >
                Generar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}
export { RptDepartamentalMenu };
